module.exports = __webpack_public_path__ + "static/media/37550001-tuE0wSgs.1fbb66ba.JPG";